module.exports = __webpack_public_path__ + "static/img/Page of Cups.c152800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Page of Cups.jpg
// module id = 1287
// module chunks = 0